import MobileDiscoveriesSection from './MobileDiscoveriesSection';

export default MobileDiscoveriesSection;
